import AppConfig from "../config/AppConfig";
var APIConfig = {
    endpoint: AppConfig.webServerUrl+"/api",
    url: (path) => APIConfig.endpoint + path
};

export default APIConfig;